export const supportedChains = [
  {
    name: 'Ethereum Mainnet',
    short_name: 'eth',
    chain: 'ETH',
    network: 'mainnet',
    chain_id: 1,
    network_id: 1,
    rpc_url:
      'https://etherscan.io/address/0x86192e6649f3d5459ae613a985cf4ccf01838380',
    native_currency: {
      symbol: 'ETH',
      name: 'Ethereum',
      decimals: '18',
      contractAddress: '',
      balance: '',
    },
  },
//   {
//     name: 'Ethereum Rinkeby',
//     short_name: 'rin',
//     chain: 'ETH',
//     network: 'rinkeby',
//     chain_id: 4,
//     network_id: 4,
//     rpc_url:
//       'https://rinkeby.etherscan.io/address/0xbc8aad452e0bb31137927169e2d334f0f0126ae5',
//     native_currency: {
//       symbol: 'ETH',
//       name: 'Ethereum',
//       decimals: '18',
//       contractAddress: '',
//       balance: '',
//     },
//   },
]

export const ERC_CONTRACT = {
  1: {
    address: '0x86192e6649f3d5459ae613a985cf4ccf01838380',
    abi: [
      {
        inputs: [
          { internalType: 'string', name: 'name_', type: 'string' },
          { internalType: 'string', name: 'symbol_', type: 'string' },
          { internalType: 'address', name: '_ownerAddress', type: 'address' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'address',
            name: 'owner',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: 'spender',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'uint256',
            name: 'value',
            type: 'uint256',
          },
        ],
        name: 'Approval',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'bytes32',
            name: '_name',
            type: 'bytes32',
          },
          {
            indexed: false,
            internalType: 'string',
            name: '_uri',
            type: 'string',
          },
          {
            indexed: false,
            internalType: 'bytes32',
            name: '_documentHash',
            type: 'bytes32',
          },
        ],
        name: 'Document',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'address',
            name: '_operator',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_to',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'uint256',
            name: '_value',
            type: 'uint256',
          },
          {
            indexed: false,
            internalType: 'bytes',
            name: '_data',
            type: 'bytes',
          },
        ],
        name: 'Issued',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'bytes32',
            name: '_partition',
            type: 'bytes32',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_operator',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_to',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'uint256',
            name: '_value',
            type: 'uint256',
          },
          {
            indexed: false,
            internalType: 'bytes',
            name: '_data',
            type: 'bytes',
          },
          {
            indexed: false,
            internalType: 'bytes',
            name: '_operatorData',
            type: 'bytes',
          },
        ],
        name: 'IssuedByPartition',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'address',
            name: 'previousOwner',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: 'newOwner',
            type: 'address',
          },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'address',
            name: '_operator',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_from',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'uint256',
            name: '_value',
            type: 'uint256',
          },
          {
            indexed: false,
            internalType: 'bytes',
            name: '_data',
            type: 'bytes',
          },
        ],
        name: 'Redeemed',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'bytes32',
            name: '_partition',
            type: 'bytes32',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_operator',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_from',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'uint256',
            name: '_value',
            type: 'uint256',
          },
          {
            indexed: false,
            internalType: 'bytes',
            name: '_operatorData',
            type: 'bytes',
          },
        ],
        name: 'RedeemedByPartition',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'address',
            name: 'from',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: 'to',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'uint256',
            name: 'value',
            type: 'uint256',
          },
        ],
        name: 'Transfer',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'bytes32',
            name: '_fromPartition',
            type: 'bytes32',
          },
          {
            indexed: false,
            internalType: 'address',
            name: '_operator',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_from',
            type: 'address',
          },
          {
            indexed: true,
            internalType: 'address',
            name: '_to',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'uint256',
            name: '_value',
            type: 'uint256',
          },
          {
            indexed: false,
            internalType: 'bytes',
            name: '_data',
            type: 'bytes',
          },
          {
            indexed: false,
            internalType: 'bytes',
            name: '_operatorData',
            type: 'bytes',
          },
        ],
        name: 'TransferByPartition',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'address',
            name: '_user',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'bool',
            name: '_isBlackListed',
            type: 'bool',
          },
        ],
        name: 'UserIsBlackListedByAdmin',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          {
            indexed: true,
            internalType: 'address',
            name: '_user',
            type: 'address',
          },
          {
            indexed: false,
            internalType: 'bool',
            name: '_status',
            type: 'bool',
          },
        ],
        name: 'UserKycStatus',
        type: 'event',
      },
      {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'MintTokenHistory',
        outputs: [
          { internalType: 'uint256', name: 'Tokens', type: 'uint256' },
          { internalType: 'uint256', name: 'Date', type: 'uint256' },
          { internalType: 'address', name: '_address', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: '_incTokenDistributed',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'owner', type: 'address' },
          { internalType: 'address', name: 'spender', type: 'address' },
        ],
        name: 'allowance',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
          { internalType: 'address', name: '_tokenHolder', type: 'address' },
        ],
        name: 'balanceOfByPartition',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_to', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'canTransfer',
        outputs: [
          { internalType: 'bytes1', name: '', type: 'bytes1' },
          { internalType: 'bytes32', name: '', type: 'bytes32' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_from', type: 'address' },
          { internalType: 'address', name: '_to', type: 'address' },
          { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'canTransferByPartition',
        outputs: [
          { internalType: 'bytes1', name: '', type: 'bytes1' },
          { internalType: 'bytes32', name: '', type: 'bytes32' },
          { internalType: 'bytes32', name: '', type: 'bytes32' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_from', type: 'address' },
          { internalType: 'address', name: '_to', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'canTransferFrom',
        outputs: [
          { internalType: 'bytes1', name: '', type: 'bytes1' },
          { internalType: 'bytes32', name: '', type: 'bytes32' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'decimals',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'subtractedValue', type: 'uint256' },
        ],
        name: 'decreaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_to', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'uint256', name: '_grams', type: 'uint256' },
          { internalType: 'uint256', name: '_timeStamp', type: 'uint256' },
          { internalType: 'string', name: '_kycUrl', type: 'string' },
          { internalType: 'string', name: '_goldId', type: 'string' },
        ],
        name: 'distributeToken',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'endIssuing',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getAllIssueHistory',
        outputs: [
          {
            components: [
              { internalType: 'uint256', name: 'timeStamp', type: 'uint256' },
              { internalType: 'uint256', name: 'tokenValue', type: 'uint256' },
              { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
              { internalType: 'address', name: '_address', type: 'address' },
            ],
            internalType: 'struct QRFID_gold.IssuedTokens[]',
            name: '',
            type: 'tuple[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getAllKycDocuments',
        outputs: [{ internalType: 'bytes32[]', name: '', type: 'bytes32[]' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getAllRedeemedTokensHistory',
        outputs: [
          {
            components: [
              { internalType: 'address', name: '_operator', type: 'address' },
              { internalType: 'address', name: '_from', type: 'address' },
              { internalType: 'uint256', name: '_value', type: 'uint256' },
              { internalType: 'bytes', name: '_data', type: 'bytes' },
            ],
            internalType: 'struct QRFID_gold.RedeemedTokens[]',
            name: '',
            type: 'tuple[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'getAllTokenSaleHistory',
        outputs: [
          {
            components: [
              { internalType: 'uint256', name: 'timeStamp', type: 'uint256' },
              { internalType: 'address', name: 'to', type: 'address' },
              { internalType: 'uint256', name: 'tokenValue', type: 'uint256' },
              { internalType: 'uint256', name: 'grams', type: 'uint256' },
              { internalType: 'string', name: 'goldId', type: 'string' },
              { internalType: 'string', name: 'kycUri', type: 'string' },
            ],
            internalType: 'struct QRFID_gold.TokenSaleData[]',
            name: '',
            type: 'tuple[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: '_docName', type: 'bytes32' },
        ],
        name: 'getDocument',
        outputs: [
          { internalType: 'string', name: '', type: 'string' },
          { internalType: 'bytes32', name: '', type: 'bytes32' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_userAddress', type: 'address' },
        ],
        name: 'getKycDocument',
        outputs: [
          { internalType: 'string', name: '', type: 'string' },
          { internalType: 'bytes32', name: '', type: 'bytes32' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'addedValue', type: 'uint256' },
        ],
        name: 'increaseAllowance',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'isIssuable',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'isOwner',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_tokenHolder', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'issue',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
          { internalType: 'address', name: '_tokenHolder', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'issueByPartition',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'uint256', name: 'value', type: 'uint256' },
          { internalType: 'address', name: '_address', type: 'address' },
        ],
        name: 'mint',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_tokenHolder', type: 'address' },
        ],
        name: 'partitionsOf',
        outputs: [{ internalType: 'bytes32[]', name: '', type: 'bytes32[]' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'redeem',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_tokenHolder', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'redeemFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'redeemHistoryOf',
        outputs: [
          {
            components: [
              { internalType: 'address', name: '_operator', type: 'address' },
              { internalType: 'address', name: '_from', type: 'address' },
              { internalType: 'uint256', name: '_value', type: 'uint256' },
              { internalType: 'bytes', name: '_data', type: 'bytes' },
            ],
            internalType: 'struct QRFID_gold.RedeemedTokens[]',
            name: '',
            type: 'tuple[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_address', type: 'address' },
          { internalType: 'bool', name: '_bool', type: 'bool' },
        ],
        name: 'setBlackList',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: '_docName', type: 'bytes32' },
          { internalType: 'string', name: '_uri', type: 'string' },
          { internalType: 'bytes32', name: '_documentHash', type: 'bytes32' },
        ],
        name: 'setDocument',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_userAddress', type: 'address' },
          { internalType: 'string', name: 'Uri', type: 'string' },
          { internalType: 'bytes32', name: '_DocumentHash', type: 'bytes32' },
        ],
        name: 'setKycDocument',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'startIssuing',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'tokenSaleHistoryOf',
        outputs: [
          {
            components: [
              { internalType: 'uint256', name: 'timeStamp', type: 'uint256' },
              { internalType: 'address', name: 'to', type: 'address' },
              { internalType: 'uint256', name: 'tokenValue', type: 'uint256' },
              { internalType: 'uint256', name: 'grams', type: 'uint256' },
              { internalType: 'string', name: 'goldId', type: 'string' },
              { internalType: 'string', name: 'kycUri', type: 'string' },
            ],
            internalType: 'struct QRFID_gold.TokenSaleData[]',
            name: '',
            type: 'tuple[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'to', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transfer',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
          { internalType: 'address', name: '_to', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'transferByPartition',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'from', type: 'address' },
          { internalType: 'address', name: 'to', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_from', type: 'address' },
          { internalType: 'address', name: '_to', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'transferFromWithData',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address', name: '_to', type: 'address' },
          { internalType: 'uint256', name: '_value', type: 'uint256' },
          { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'transferWithData',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: '', type: 'address' }],
        name: 'userKycStatus',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      { stateMutability: 'payable', type: 'receive' },
    ],
  },
//   4: {
//     address: '0xbc8aad452e0bb31137927169e2d334f0f0126ae5',
//     abi: [
//       {
//         inputs: [
//           { internalType: 'string', name: 'name_', type: 'string' },
//           { internalType: 'string', name: 'symbol_', type: 'string' },
//           { internalType: 'address', name: '_ownerAddress', type: 'address' },
//         ],
//         stateMutability: 'nonpayable',
//         type: 'constructor',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'address',
//             name: 'owner',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: 'spender',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'uint256',
//             name: 'value',
//             type: 'uint256',
//           },
//         ],
//         name: 'Approval',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'bytes32',
//             name: '_name',
//             type: 'bytes32',
//           },
//           {
//             indexed: false,
//             internalType: 'string',
//             name: '_uri',
//             type: 'string',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes32',
//             name: '_documentHash',
//             type: 'bytes32',
//           },
//         ],
//         name: 'Document',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_operator',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_to',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'uint256',
//             name: '_value',
//             type: 'uint256',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes',
//             name: '_data',
//             type: 'bytes',
//           },
//         ],
//         name: 'Issued',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'bytes32',
//             name: '_partition',
//             type: 'bytes32',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_operator',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_to',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'uint256',
//             name: '_value',
//             type: 'uint256',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes',
//             name: '_data',
//             type: 'bytes',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes',
//             name: '_operatorData',
//             type: 'bytes',
//           },
//         ],
//         name: 'IssuedByPartition',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'address',
//             name: 'previousOwner',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: 'newOwner',
//             type: 'address',
//           },
//         ],
//         name: 'OwnershipTransferred',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_operator',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_from',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'uint256',
//             name: '_value',
//             type: 'uint256',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes',
//             name: '_data',
//             type: 'bytes',
//           },
//         ],
//         name: 'Redeemed',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'bytes32',
//             name: '_partition',
//             type: 'bytes32',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_operator',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_from',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'uint256',
//             name: '_value',
//             type: 'uint256',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes',
//             name: '_operatorData',
//             type: 'bytes',
//           },
//         ],
//         name: 'RedeemedByPartition',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'address',
//             name: 'from',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: 'to',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'uint256',
//             name: 'value',
//             type: 'uint256',
//           },
//         ],
//         name: 'Transfer',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'bytes32',
//             name: '_fromPartition',
//             type: 'bytes32',
//           },
//           {
//             indexed: false,
//             internalType: 'address',
//             name: '_operator',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_from',
//             type: 'address',
//           },
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_to',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'uint256',
//             name: '_value',
//             type: 'uint256',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes',
//             name: '_data',
//             type: 'bytes',
//           },
//           {
//             indexed: false,
//             internalType: 'bytes',
//             name: '_operatorData',
//             type: 'bytes',
//           },
//         ],
//         name: 'TransferByPartition',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_user',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'bool',
//             name: '_isBlackListed',
//             type: 'bool',
//           },
//         ],
//         name: 'UserIsBlackListedByAdmin',
//         type: 'event',
//       },
//       {
//         anonymous: false,
//         inputs: [
//           {
//             indexed: true,
//             internalType: 'address',
//             name: '_user',
//             type: 'address',
//           },
//           {
//             indexed: false,
//             internalType: 'bool',
//             name: '_status',
//             type: 'bool',
//           },
//         ],
//         name: 'UserKycStatus',
//         type: 'event',
//       },
//       {
//         inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
//         name: 'MintTokenHistory',
//         outputs: [
//           { internalType: 'uint256', name: 'Tokens', type: 'uint256' },
//           { internalType: 'uint256', name: 'Date', type: 'uint256' },
//           { internalType: 'address', name: '_address', type: 'address' },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: '_incTokenDistributed',
//         outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: 'owner', type: 'address' },
//           { internalType: 'address', name: 'spender', type: 'address' },
//         ],
//         name: 'allowance',
//         outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: 'spender', type: 'address' },
//           { internalType: 'uint256', name: 'amount', type: 'uint256' },
//         ],
//         name: 'approve',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
//         name: 'balanceOf',
//         outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
//           { internalType: 'address', name: '_tokenHolder', type: 'address' },
//         ],
//         name: 'balanceOfByPartition',
//         outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_to', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'canTransfer',
//         outputs: [
//           { internalType: 'bytes1', name: '', type: 'bytes1' },
//           { internalType: 'bytes32', name: '', type: 'bytes32' },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_from', type: 'address' },
//           { internalType: 'address', name: '_to', type: 'address' },
//           { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'canTransferByPartition',
//         outputs: [
//           { internalType: 'bytes1', name: '', type: 'bytes1' },
//           { internalType: 'bytes32', name: '', type: 'bytes32' },
//           { internalType: 'bytes32', name: '', type: 'bytes32' },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_from', type: 'address' },
//           { internalType: 'address', name: '_to', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'canTransferFrom',
//         outputs: [
//           { internalType: 'bytes1', name: '', type: 'bytes1' },
//           { internalType: 'bytes32', name: '', type: 'bytes32' },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'decimals',
//         outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: 'spender', type: 'address' },
//           { internalType: 'uint256', name: 'subtractedValue', type: 'uint256' },
//         ],
//         name: 'decreaseAllowance',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_to', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'uint256', name: '_grams', type: 'uint256' },
//           { internalType: 'uint256', name: '_timeStamp', type: 'uint256' },
//           { internalType: 'string', name: '_kycUrl', type: 'string' },
//           { internalType: 'string', name: '_goldId', type: 'string' },
//         ],
//         name: 'distributeToken',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'endIssuing',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'getAllIssueHistory',
//         outputs: [
//           {
//             components: [
//               { internalType: 'uint256', name: 'timeStamp', type: 'uint256' },
//               { internalType: 'uint256', name: 'tokenValue', type: 'uint256' },
//               { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
//               { internalType: 'address', name: '_address', type: 'address' },
//             ],
//             internalType: 'struct QRFID_gold.IssuedTokens[]',
//             name: '',
//             type: 'tuple[]',
//           },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'getAllKycDocuments',
//         outputs: [{ internalType: 'bytes32[]', name: '', type: 'bytes32[]' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'getAllRedeemedTokensHistory',
//         outputs: [
//           {
//             components: [
//               { internalType: 'address', name: '_operator', type: 'address' },
//               { internalType: 'address', name: '_from', type: 'address' },
//               { internalType: 'uint256', name: '_value', type: 'uint256' },
//               { internalType: 'bytes', name: '_data', type: 'bytes' },
//             ],
//             internalType: 'struct QRFID_gold.RedeemedTokens[]',
//             name: '',
//             type: 'tuple[]',
//           },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'getAllTokenSaleHistory',
//         outputs: [
//           {
//             components: [
//               { internalType: 'uint256', name: 'timeStamp', type: 'uint256' },
//               { internalType: 'address', name: 'to', type: 'address' },
//               { internalType: 'uint256', name: 'tokenValue', type: 'uint256' },
//               { internalType: 'uint256', name: 'grams', type: 'uint256' },
//               { internalType: 'string', name: 'goldId', type: 'string' },
//               { internalType: 'string', name: 'kycUri', type: 'string' },
//             ],
//             internalType: 'struct QRFID_gold.TokenSaleData[]',
//             name: '',
//             type: 'tuple[]',
//           },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'bytes32', name: '_docName', type: 'bytes32' },
//         ],
//         name: 'getDocument',
//         outputs: [
//           { internalType: 'string', name: '', type: 'string' },
//           { internalType: 'bytes32', name: '', type: 'bytes32' },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_userAddress', type: 'address' },
//         ],
//         name: 'getKycDocument',
//         outputs: [
//           { internalType: 'string', name: '', type: 'string' },
//           { internalType: 'bytes32', name: '', type: 'bytes32' },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: 'spender', type: 'address' },
//           { internalType: 'uint256', name: 'addedValue', type: 'uint256' },
//         ],
//         name: 'increaseAllowance',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'isIssuable',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'isOwner',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_tokenHolder', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'issue',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
//           { internalType: 'address', name: '_tokenHolder', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'issueByPartition',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'uint256', name: 'value', type: 'uint256' },
//           { internalType: 'address', name: '_address', type: 'address' },
//         ],
//         name: 'mint',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'name',
//         outputs: [{ internalType: 'string', name: '', type: 'string' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'owner',
//         outputs: [{ internalType: 'address', name: '', type: 'address' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_tokenHolder', type: 'address' },
//         ],
//         name: 'partitionsOf',
//         outputs: [{ internalType: 'bytes32[]', name: '', type: 'bytes32[]' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'redeem',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_tokenHolder', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'redeemFrom',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
//         name: 'redeemHistoryOf',
//         outputs: [
//           {
//             components: [
//               { internalType: 'address', name: '_operator', type: 'address' },
//               { internalType: 'address', name: '_from', type: 'address' },
//               { internalType: 'uint256', name: '_value', type: 'uint256' },
//               { internalType: 'bytes', name: '_data', type: 'bytes' },
//             ],
//             internalType: 'struct QRFID_gold.RedeemedTokens[]',
//             name: '',
//             type: 'tuple[]',
//           },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_address', type: 'address' },
//           { internalType: 'bool', name: '_bool', type: 'bool' },
//         ],
//         name: 'setBlackList',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'bytes32', name: '_docName', type: 'bytes32' },
//           { internalType: 'string', name: '_uri', type: 'string' },
//           { internalType: 'bytes32', name: '_documentHash', type: 'bytes32' },
//         ],
//         name: 'setDocument',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_userAddress', type: 'address' },
//           { internalType: 'string', name: 'Uri', type: 'string' },
//           { internalType: 'bytes32', name: '_DocumentHash', type: 'bytes32' },
//         ],
//         name: 'setKycDocument',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'startIssuing',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'symbol',
//         outputs: [{ internalType: 'string', name: '', type: 'string' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
//         name: 'tokenSaleHistoryOf',
//         outputs: [
//           {
//             components: [
//               { internalType: 'uint256', name: 'timeStamp', type: 'uint256' },
//               { internalType: 'address', name: 'to', type: 'address' },
//               { internalType: 'uint256', name: 'tokenValue', type: 'uint256' },
//               { internalType: 'uint256', name: 'grams', type: 'uint256' },
//               { internalType: 'string', name: 'goldId', type: 'string' },
//               { internalType: 'string', name: 'kycUri', type: 'string' },
//             ],
//             internalType: 'struct QRFID_gold.TokenSaleData[]',
//             name: '',
//             type: 'tuple[]',
//           },
//         ],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [],
//         name: 'totalSupply',
//         outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: 'to', type: 'address' },
//           { internalType: 'uint256', name: 'amount', type: 'uint256' },
//         ],
//         name: 'transfer',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'bytes32', name: '_partition', type: 'bytes32' },
//           { internalType: 'address', name: '_to', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'transferByPartition',
//         outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: 'from', type: 'address' },
//           { internalType: 'address', name: 'to', type: 'address' },
//           { internalType: 'uint256', name: 'amount', type: 'uint256' },
//         ],
//         name: 'transferFrom',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_from', type: 'address' },
//           { internalType: 'address', name: '_to', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'transferFromWithData',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: 'newOwner', type: 'address' },
//         ],
//         name: 'transferOwnership',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [
//           { internalType: 'address', name: '_to', type: 'address' },
//           { internalType: 'uint256', name: '_value', type: 'uint256' },
//           { internalType: 'bytes', name: '_data', type: 'bytes' },
//         ],
//         name: 'transferWithData',
//         outputs: [],
//         stateMutability: 'nonpayable',
//         type: 'function',
//       },
//       {
//         inputs: [{ internalType: 'address', name: '', type: 'address' }],
//         name: 'userKycStatus',
//         outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
//         stateMutability: 'view',
//         type: 'function',
//       },
//       { stateMutability: 'payable', type: 'receive' },
//     ],
//   },
}
